import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConfigService } from '../../../../shared/services/config.service';

@Component({
    selector: 'app-video-dialog',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './video-dialog.component.html',
    styleUrls: ['./video-dialog.component.scss']
})
export class VideoPlayDialogComponent implements OnInit, OnDestroy {
    safeVideoUrl: SafeResourceUrl | null = null;

    constructor(
        public dialogRef: MatDialogRef<VideoPlayDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private sanitizer: DomSanitizer,
        private configService: ConfigService
    ) {}

    ngOnInit(): void {
        if (this.data?.videoUrl) {
            this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.videoUrl);
        } else {
            this.configService.getWelcomeVideoUrl().subscribe(url => {
                if (url) {
                    this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                }
            });
        }
    }

    close(): void {
        this.dialogRef.close();
    }

    ngOnDestroy(): void {}
}
